<template lang="pug">
	.enroll-now-component(v-if="ready")
		a.btn.sfc-blue.sfc-enroll-now-button(v-if="plan.has_enroll_now" target="_blank" :href="`${enrollNowUrl}`" @click="trackEnrollNowClick()")
			| ENROLL NOW
		.secure-message.text-nowrap(v-if="plan.has_enroll_now")
			.enroll-img
			span
				| {{plan.enroll_now_count || '0' | currency('',0)}} clicked to enroll
		a.btn.sfc-blue.plan-details(v-else :href="plan.plan_details_url" @click="trackPlanDetailsClick()" target="_blank")
			| PLAN DETAILS

</template>
<style lang="stylus" scoped>
@import '../assets/css/variables.styl';

a.btn
	font-size: body-font-size-sm

.enroll-now-component
	.secure-message
		margin-top: 15px
		font-size: 12px
		.enroll-img
			border-radius(50%)
			height: 12px
			width: 12px
			margin-right: 5px
			background: url('https://web-resources.savingforcollege.com/images/icon-star-circle.svg') no-repeat
			background-size: contain
			display: inline-block
			position: relative
			top: 2px
	.sfc-blue
		width: 100%
		border-color: #D0021B !important
		background-color: #F05B33 !important
		box-sizing: border-box
		text-align: center
		&:hover
			background-color: #e2491f !important
</style>
<script>
	import Vue from 'vue'
	import Vue2Filters from 'vue2-filters'
	Vue.use(Vue2Filters)

	import {trackAnalyticsAction} from '../track'
	export default {
		async created() {
			this.ready = true
		},
		data() {
			return {
				ready: false
			}
		},

		props: {
			plan: {
				type: Object,
				required: true
			},
			clickSource: {
				type: String,
				default: "Unknown"
			}
		},

		computed: {
			enrollNowUrl(){
				return `https://www.savingforcollege.com/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${this.plan.id}&click_source=${this.clickSource}`
			}
		},

		methods: {

			trackEnrollNowClick() {
				trackAnalyticsAction("Enroll Now Button", "click", "performance_ranking", 0)
			},

			trackPlanDetailsClick() {
				trackAnalyticsAction("Learn More Click", "performance_ranking", 1, 0)
			}
		}
	}
</script>
